import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SavingsIcon from '@mui/icons-material/Savings';
import FavoriteIcon from '@mui/icons-material/Favorite';
const carouselImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/9gjv98psHfxUwBmLJAsLjA/Whisk_66c123e469654c7b4b7448a9d1c40285dr.png',
  alt: 'Freezer organizado con comidas preparadas y etiquetadas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dZRvQeDeqPXxTtTpxHVK2y/Whisk_52a43564054866e8f5c4644cc8596989dr.png',
  alt: 'Comida congelada lista para recalentar'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oqSY2ztiZp56gNtovPBUnV/Whisk_d4c760093bded93bb004e8815cdca199dr.png',
  alt: 'Porciones de comida congelada variadas'
}];
export function SolutionSection() {
  const [currentImage, setCurrentImage] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % carouselImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  const features = [{
    icon: <AccessTimeIcon sx={{
      fontSize: {
        xs: 32,
        md: 48
      }
    }} className="text-[#2D5A27]" data-id="element-115" />,
    title: 'Ahorrá Tiempo',
    description: 'Cocinás 1 domingo, descansás 30 días.'
  }, {
    icon: <SavingsIcon sx={{
      fontSize: {
        xs: 32,
        md: 48
      }
    }} className="text-[#2D5A27]" data-id="element-116" />,
    title: 'Ahorrá Dinero',
    description: 'Ganale a la inflación con compras mayoristas inteligentes.'
  }, {
    icon: <FavoriteIcon sx={{
      fontSize: {
        xs: 32,
        md: 48
      }
    }} className="text-[#2D5A27]" data-id="element-117" />,
    title: 'Salud Real',
    description: 'Comida casera, nutritiva y sin ultraprocesados siempre lista.'
  }];
  return <section className="py-10 md:py-16 px-4 md:px-8 max-w-6xl mx-auto" data-id="element-118">
      <FadeIn data-id="element-119">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-6 md:mb-10" data-id="element-120">
          Presentamos:{' '}
          <span className="text-[#2D5A27]" data-id="element-121">Arquitectura del Freezer™</span>
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-122">
        {features.map((feature, index) => <FadeIn key={index} delay={0.2 * (index + 1)} className="flex flex-col items-center text-center" data-id="element-123">
            <div className="w-14 h-14 md:w-20 md:h-20 bg-green-50 rounded-2xl flex items-center justify-center mb-3 md:mb-6 shadow-sm border border-green-100" data-id="element-124">
              {feature.icon}
            </div>
            <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-4" data-id="element-125">
              {feature.title}
            </h3>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-126">
              {feature.description}
            </p>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} data-id="element-127">
        <div className="mt-8 md:mt-12 max-w-3xl mx-auto" data-id="element-128">
          <div className="relative rounded-2xl overflow-hidden shadow-lg aspect-[4/3]" data-id="element-129">
            <AnimatePresence mode="wait" data-id="element-130">
              <motion.img key={currentImage} src={carouselImages[currentImage].src} alt={carouselImages[currentImage].alt} initial={{
              opacity: 0,
              x: 60
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -60
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="absolute inset-0 w-full h-full object-cover" data-id="element-131" />
            </AnimatePresence>
          </div>
          <div className="flex justify-center gap-2 mt-4" data-id="element-132">
            {carouselImages.map((_, index) => <button key={index} onClick={() => setCurrentImage(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === currentImage ? 'bg-[#2D5A27] w-6' : 'bg-gray-300'}`} aria-label={`Ver imagen ${index + 1}`} data-id="element-133" />)}
          </div>
        </div>
      </FadeIn>
    </section>;
}